import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { getUserProfileInfo } from "../api";
import { Col, Row, Container } from "reactstrap";
import { Right } from "./right";
import { Left } from "./left";
import { Alert, Shortcut } from "../shared";
import { setUserInfo } from "../redux";
import { useTranslation } from "react-i18next";

const PanelComp = (props) => {
  const { t } = useTranslation();
  let token = Cookies.get("token");
  const dispatch = useDispatch();
  const [isPhone, setIsPhone] = useState(false);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }

    if (!token) {
      props.history.push("/login");
    } else {
      getUserProfileInfo(token)
        .then((res) => {
          dispatch(setUserInfo(res.data.data));
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            }));
            setTimeout(() => {
              setShowAlert((prevState) => ({
                ...prevState,
                show: false,
              }));
            }, 5000);
          }
        });
    }
  }, []);

  return (
    <Container fluid className="panel-container">
      <Row className="justify-content-center">
        <Col xs="12" md="10" lg="8" xl="7" className="right-section-wrapper p-0">
          <Right />
          {isPhone && <Shortcut />}
        </Col>
      </Row>
      {!isPhone && <Shortcut />}
    </Container>
  );
};

const Panel = withRouter(PanelComp);

export { Panel };
